import React from 'react';
import { Document, Page, Text, View, StyleSheet, Image } from '@react-pdf/renderer';
import { PdfWatermark } from './PdfWatermark';

const styles = StyleSheet.create({
  page: { padding: 20, fontFamily: 'Helvetica', fontSize: 9 },
  header: { flexDirection: 'row', justifyContent: 'space-between', borderBottomWidth: 2, borderBottomColor: '#e00000', paddingBottom: 10, marginBottom: 15 },
  headerInfo: { flexDirection: 'column' },
  headerTitle: { fontSize: 18, fontFamily: 'Helvetica-Bold', textTransform: 'uppercase', marginBottom: 4, color: '#111111' },
  headerSubtitle: { fontSize: 10, color: '#444444', marginBottom: 2 },
  headerLogoContainer: { flexDirection: 'row', alignItems: 'center' },
  teamName: { fontSize: 14, fontFamily: 'Helvetica-Bold', color: '#888888', fontStyle: 'italic', marginRight: 10 },
  logo: { height: 40, width: 120, objectFit: 'contain' },
  
  sectionTitle: { fontSize: 12, fontFamily: 'Helvetica-Bold', color: '#e00000', borderBottomWidth: 1, borderBottomColor: '#eeeeee', paddingBottom: 3, marginTop: 15, marginBottom: 10, textTransform: 'uppercase' },
  
  table: { width: '100%', marginBottom: 10 },
  tableHeader: { flexDirection: 'row', backgroundColor: '#f0f0f0', borderBottomWidth: 1, borderBottomColor: '#cccccc', padding: 5 },
  tableRow: { flexDirection: 'row', borderBottomWidth: 1, borderBottomColor: '#eeeeee', padding: 5 },
  
  col1: { width: '15%' }, // Date
  col2: { width: '25%' }, // Type / Category
  col3: { width: '15%' }, // Status
  col4: { width: '45%' }, // Description
  
  headerText: { fontFamily: 'Helvetica-Bold', fontSize: 8 },
  cellText: { fontSize: 8, color: '#333333' },
  
  footerText: { fontSize: 7, color: '#888888', textAlign: 'center', marginTop: 15, borderTopWidth: 1, borderTopColor: '#eeeeee', paddingTop: 5 }
});

const VehicleHistoryPdf = ({ vehicle, teamData, teamLogoBase64, issuesData, woData, displayDate, showWatermark = true }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {showWatermark && <PdfWatermark />}
        {/* HEADER */}
        <View style={styles.header}>
          <View style={styles.headerInfo}>
            <Text style={styles.headerTitle}>Vehicle History Report</Text>
            <Text style={styles.headerSubtitle}>{vehicle?.marca} {vehicle?.modello} | #{vehicle?.numeroGara || 'N/A'}</Text>
            <Text style={styles.headerSubtitle}>Date: {displayDate}</Text>
          </View>
          <View style={styles.headerLogoContainer}>
            {teamLogoBase64 ? (
              <Image src={teamLogoBase64} style={styles.logo} allowDangerousPaths />
            ) : (
              <Text style={styles.teamName}>{teamData?.nomeTeam || 'Team Name'}</Text>
            )}
          </View>
        </View>

        {/* ISSUES SECTION */}
        <Text style={styles.sectionTitle}>Registro Guasti / Issues Log</Text>
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={[styles.col1, styles.headerText]}>Data</Text>
            <Text style={[styles.col2, styles.headerText]}>Categoria</Text>
            <Text style={[styles.col3, styles.headerText]}>Stato</Text>
            <Text style={[styles.col4, styles.headerText]}>Descrizione / Soluzione</Text>
          </View>
          {issuesData && issuesData.length > 0 ? issuesData.map((item, idx) => (
            <View key={idx} style={styles.tableRow} wrap={false}>
              <Text style={[styles.col1, styles.cellText]}>{item.Data || item.Date}</Text>
              <Text style={[styles.col2, styles.cellText]}>{item.Categoria || item.Category}</Text>
              <Text style={[styles.col3, styles.cellText]}>{item.Stato || item.Status}</Text>
              <View style={styles.col4}>
                <Text style={styles.cellText}>{item.Descrizione || item.Description}</Text>
                {(item.Soluzione || item.Resolution) && (item.Soluzione !== '-' && item.Resolution !== '-') && (
                  <Text style={[styles.cellText, { color: '#008800', marginTop: 2 }]}>Sol: {item.Soluzione || item.Resolution}</Text>
                )}
              </View>
            </View>
          )) : (
            <View style={styles.tableRow}><Text style={styles.cellText}>Nessun dato registrato</Text></View>
          )}
        </View>

        {/* WORK ORDERS SECTION */}
        <Text style={styles.sectionTitle}>Ordini di Lavoro / Work Orders</Text>
        <View style={styles.table}>
          <View style={styles.tableHeader}>
            <Text style={[styles.col1, styles.headerText]}>Data</Text>
            <Text style={[styles.col2, styles.headerText]}>Titolo</Text>
            <Text style={[styles.col3, styles.headerText]}>Stato</Text>
            <Text style={[styles.col4, styles.headerText]}>Note</Text>
          </View>
          {woData && woData.length > 0 ? woData.map((item, idx) => (
            <View key={idx} style={styles.tableRow} wrap={false}>
              <Text style={[styles.col1, styles.cellText]}>{item.Data || item.Date}</Text>
              <Text style={[styles.col2, styles.cellText]}>{item.Titolo || item.Title}</Text>
              <Text style={[styles.col3, styles.cellText]}>{item.Stato || item.Status}</Text>
              <Text style={[styles.col4, styles.cellText]}>{item.Note || item.Notes}</Text>
            </View>
          )) : (
            <View style={styles.tableRow}><Text style={styles.cellText}>Nessun dato registrato</Text></View>
          )}
        </View>

        {/* FOOTER */}
        <Text style={styles.footerText}>
          Generato con Motorsport Suite - Tutti i diritti riservati - www.motorsportsuite.com
        </Text>
      </Page>
    </Document>
  );
};

export default VehicleHistoryPdf;
